<template>
  <RF-Dialog
    :cpntLargura='"650px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='finRegVariosFechar'>
    <template slot='titulo'>      
      <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
      Registrar no Financeiro
    </template>

    <template slot='conteudo'>
      <div class="fin-reg-var">
        <!-- SETA A FRASE INICIAL -->
        Selecione abaixo o contato e o tipo de receita para o{{ registros.length >= 2 ? 's' : '' }} novo{{ registros.length >= 2 ? 's' : '' }} registro{{ registros.length >= 2 ? 's' : '' }}

        <!-- MONTA A TABELA DOS DADOS A SEREM SALVOS -->
        <div>
          <table>
            <tr>  
              <td>
                Valor
              </td>
              <td>
                Vencimento
              </td>
            </tr>
            <tr v-for="(reg, indexR) in registros" :key="'reg--' + indexR">
              <td>
                <span v-html="reg._valor"></span>
              </td>
              <td>
                <span v-html="reg._vcto"></span>
              </td>
            </tr>
          </table>
        </div>

        <!-- SETA OS CAMPOS QUE DEVEM SER SELECIONADOS -->
        <div class="campos">
          <App-Autocompletar :data-time="time" class="fin-reg-var--contato"
            :cpntStatus='campos.contato.status'
            :cpntId='campos.contato.id'
            :class='campos.contato.class'
            :cpntTabIndex='campos.contato.tabIndex'
            :cpntNome='campos.contato.nome'
            :cpntValue='campos.contato.value'
            :cpntMensagem='campos.contato.mensagem'
            :cpntMensagemTipo='campos.contato.mensagemTipo'
            :cpntDisabled='campos.contato.disabled'
            :cpntMostrar='campos.contato.mostrar'
            :cpntExplica='campos.contato.explica'
            :cpntPlaceholder='campos.contato.placeholder'
            :cpntValueRef='campos.contato.valueRef'
            :cpntRouter='campos.contato.router'
            :cpntMethod='campos.contato.method'
            :cpntField='campos.contato.field'
            :cpntWhere='campos.contato.where'
            :cpntAddButForm='campos.contato.addButForm'
            :cpntKeyMostra='campos.contato.keyMostra'
            :cpntTipoOrder='campos.contato.tipoOrder'
            :cpntOrder='campos.contato.order'
            :cpntOptions='campos.contato.options'
            :cpntKeyValue='campos.contato.keyValue'
            :cpntSearchMinimo='campos.contato.searchMinimo'
            :cpntMask='campos.contato.mask'
            :cpntOptionInicialNome='campos.contato.optionInicialNome'
            :cpntOptionInicialValue='campos.contato.optionInicialValue'
            :cpntNewOption='campos.contato.newOption'

            :cpntOnChange='campos.contato.onChange'
            :cpntOnBlur='campos.contato.onBlur'
            :cpntOnRealizaBusca='campos.contato.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.contato.onKeyPressEnter'
            ref="contato"
          ></App-Autocompletar>

          <App-Select :data-time="time" class="fin-reg-var--tpPag"
            :cpntStatus='campos.tpPag.status'
            :cpntId='campos.tpPag.id'
            :class='campos.tpPag.class'
            :cpntTabIndex='campos.tpPag.tabIndex'
            :cpntNome='campos.tpPag.nome'
            :cpntValue='campos.tpPag.value'
            :cpntMensagem='campos.tpPag.mensagem'
            :cpntMensagemTipo='campos.tpPag.mensagemTipo'
            :cpntDisabled='campos.tpPag.disabled'
            :cpntMostrar='campos.tpPag.mostrar'
            :cpntExplica='campos.tpPag.explica'
            :cpntPlaceholder='campos.tpPag.placeholder'
            :cpntValueRef='campos.tpPag.valueRef'
            :cpntRouter='campos.tpPag.router'
            :cpntMethod='campos.tpPag.method'
            :cpntField='campos.tpPag.field'
            :cpntWhere='campos.tpPag.where'
            :cpntAddButForm='campos.tpPag.addButForm'
            :cpntKeyMostra='campos.tpPag.keyMostra'
            :cpntTipoOrder='campos.tpPag.tipoOrder'
            :cpntOrder='campos.tpPag.order'
            :cpntOptions='campos.tpPag.options'
            :cpntKeyValue='campos.tpPag.keyValue'
            :cpntSearchMinimo='campos.tpPag.searchMinimo'
            :cpntMask='campos.tpPag.mask'
            :cpntOptionInicialNome='campos.tpPag.optionInicialNome'
            :cpntOptionInicialValue='campos.tpPag.optionInicialValue'
            :cpntNewOption='campos.tpPag.newOption'
            
            :cpntOnBuscarOptions='campos.tpPag.onBuscarOptions'
            :cpntOnChange='campos.tpPag.onChange'
            :cpntOnBlur='campos.tpPag.onBlur'
            :cpntOnRealizaBusca='campos.tpPag.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.tpPag.onKeyPressEnter'
            ref="tpPag"
          ></App-Select>

          <App-Select :data-time="time" class="fin-reg-var--centro"
            :cpntStatus='campos.centro.status'
            :cpntId='campos.centro.id'
            :class='campos.centro.class'
            :cpntTabIndex='campos.centro.tabIndex'
            :cpntNome='campos.centro.nome'
            :cpntValue='campos.centro.value'
            :cpntMensagem='campos.centro.mensagem'
            :cpntMensagemTipo='campos.centro.mensagemTipo'
            :cpntDisabled='campos.centro.disabled'
            :cpntMostrar='campos.centro.mostrar'
            :cpntExplica='campos.centro.explica'
            :cpntPlaceholder='campos.centro.placeholder'
            :cpntValueRef='campos.centro.valueRef'
            :cpntRouter='campos.centro.router'
            :cpntMethod='campos.centro.method'
            :cpntField='campos.centro.field'
            :cpntWhere='campos.centro.where'
            :cpntAddButForm='campos.centro.addButForm'
            :cpntKeyMostra='campos.centro.keyMostra'
            :cpntTipoOrder='campos.centro.tipoOrder'
            :cpntOrder='campos.centro.order'
            :cpntOptions='campos.centro.options'
            :cpntKeyValue='campos.centro.keyValue'
            :cpntSearchMinimo='campos.centro.searchMinimo'
            :cpntMask='campos.centro.mask'
            :cpntOptionInicialNome='campos.centro.optionInicialNome'
            :cpntOptionInicialValue='campos.centro.optionInicialValue'
            :cpntNewOption='campos.centro.newOption'
            
            :cpntOnBuscarOptions='campos.centro.onBuscarOptions'
            :cpntOnChange='campos.centro.onChange'
            :cpntOnBlur='campos.centro.onBlur'
            :cpntOnRealizaBusca='campos.centro.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.centro.onKeyPressEnter'
            ref="centro"
          ></App-Select>
        </div>

        <App-Button :cpntClass="'btn btn-primary'" @onClick="finRegVariosInserirFinanceiro">Inserir no Financeiro</App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .fin-reg-var {
    text-align: center;
  }
    .fin-reg-var > div { 
      padding-top: 15px;
      padding-bottom: 15px;
    }
      .fin-reg-var > div > table {
        width: 450px;
        margin: 0px auto;
      }
        .fin-reg-var > div > table > tr:first-child > td {
          font-weight: bold;
          color: #666;
          background: #e6e6e6;
          padding: 5px;
          border: 1px solid #d9d9d9;
        }
        .fin-reg-var > div > table > tr:not(:first-child) > td {
          padding: 5px;
          background: #f6f6f6;
          border: 1px solid #ccc;
        }

    .fin-reg-var > .campos {
      width: 600px;
      margin: 0px auto;
    }
      .fin-reg-var > .campos > div {
        display: inline-block;
        width: calc((100% / 3) - (20px / 3));
      }
        .fin-reg-var > .campos > div:not(:last-child) {
          margin-right: 10px;
        }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntIds: {
        required: true,
        type: Array
      },
      cpntBancoId: {
        required: true,
        type: String
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        registros: [],
        tpRegistro: '',
        campos: {
          tpPag: {
            id: 'fin-reg-var--tpPag',
            status: '',
            nome: 'Tipo Pagamento',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finRegVariosBuscarTipoDePagamento,
            onChange: this.finRegVariosOnChangeValue
          },
          centro: {
            id: 'fin-reg-var--centro',
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finRegVariosBuscarCentroCusto,
            onChange: this.finRegVariosOnChangeValue
          },
          contato: {
            id: 'fin-reg-var--contato',
            status: '',
            nome: 'Contato',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo contato' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.finRegVariosOnNovoContato
            },
            mostrar: true,
            value: '',
            valueIni: '',
            valueRef: '',
            apiEnv: 'id_for',
            onChange: this.finRegVariosOnChangeValue
          },
          conta: {
            id: 'fin-con-ban-conciliar--conta',
            status: '',
            nome: 'Conta',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: true,
            onChange: this.finConBanConciliarOnChangeValue
          },
        }
      }
    },
    mounted: function () {
      this.finRegVariosIniciar()
    },
    methods: {
      finRegVariosFechar: function (atualizar, vetor) {
        this.cpntFecharFormulario(atualizar, vetor)
      },
      finRegVariosSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegVariosIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.finRegVariosSetarStatusGeral('carregando')

        // BUSCA OS REGISTROS NA API
        this.finRegVariosBuscarRegistros((registro) => {          
          // SETA OS REGISTROS RECEBIDOS
          this.registros = registro

          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'id', o: '=', v: this.cpntBancoId } ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/config/conta/get/', 'GET', queryGet, (retorno) => {
            // TRATA OS VALORES RECEBIDOS
            for (var indexR in retorno.data) {
              // INICIA A VARIAVEL COM O NOME
              retorno.data[indexR].nome = ''

              // MONTA O NOME DO BANCO A SER MOSTRADO
              if ([ '1' ].indexOf(retorno.data[indexR].id) !== -1) {
                retorno.data[indexR].nome = retorno.data[indexR].id_banco
              } else {
                // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
                retorno.data[indexR]._img = '/img/banco/' + retorno.data[indexR].id_banco + '.png'

                // ADICIONA O NUMERO DA AGENCIA
                if ([ '', null, undefined ].indexOf(retorno.data[indexR].agencia) === -1) {
                  // SETA O NUMERO DA AGENCIA
                  retorno.data[indexR].nome = 'AG.' + retorno.data[indexR].agencia

                  // SETA O DIGITO DA AGENCIA
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].agencia_dv) === -1) {
                    retorno.data[indexR].nome += '-' + retorno.data[indexR].agencia_dv
                  }
                }
                
                // ADICIONA O NUMERO DA CONTA
                if ([ '', null, undefined ].indexOf(retorno.data[indexR].conta) === -1) {
                  // SETA A INICIAL DA CONTA
                  retorno.data[indexR].nome += ' C'

                  // SETA O TIPO DA CONTA
                  switch (retorno.data[indexR].tp_conta) {
                    case '1':
                      retorno.data[indexR].nome += 'C'
                      break

                    case '2':
                      retorno.data[indexR].nome += 'P'
                      break
                  }

                  // FINALIZA O NOME DA CONTA
                  retorno.data[indexR].nome += '.' + retorno.data[indexR].conta

                  // SETA O DIGITO DA CONTA
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].conta_dv) === -1) {
                    retorno.data[indexR].nome += '-' + retorno.data[indexR].conta_dv
                  }
                }
              }
            }

            // SETA OS DADOS DA CONTA
            this.campos.conta.value = retorno.data[0]

            // SETA O FOCUS NO CAMPO
            this.finRegVariosSetaFocusCampo('contato')
  
            // SETA O STATUS DA PAGINA
            this.finRegVariosSetarStatusGeral('')
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.statusOfx = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        })
      },
      finRegVariosSetaFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.finRegVariosSetaFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs) === -1 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      finRegVariosBuscarRegistros: function (callback, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, id_conta: null, type: null, date: null, amount: null, name: null, memo: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // SETA A CONTA QUE DEVE BUSCAR
          queryGet.where.aAnd.push({ f: 'id', o: 'in', v: this.cpntIds.join() })

          // SETA A ORDENAÇÃO QUE DEVE APLICAR
          queryGet.order = { date: 'asc', amount: 'asc' }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/ofx/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finRegVariosBuscarRegistros(callback, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.statusOfx = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // IMPORTA BIBLIOTECA DEPENDENTE
          var moment = require('moment')

          // FORMATAR OS VALORES RECEBIDOS
          for (var indexL in registros) {
            // SETA O VALOR REAL DO CAMPO
            registros[indexL].original = registros[indexL].amount

            // REMOVE O PONTO PARA FORMATAR CORRETAMENTE O CAMPO
            registros[indexL].valor = registros[indexL].amount.replace('.', '')
            registros[indexL].valor = registros[indexL].valor.replace('-', '')

            // FORMATA O VALOR RECEBIDO
            registros[indexL]._valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', registros[indexL].valor)

            // SETA A DATA DE VENCIMENTO DO REGISTRO
            registros[indexL]._vcto = registros[indexL].date

            // FORMATA O CAMPO
            registros[indexL]._vcto = moment(registros[indexL]._vcto, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')

            // INICIA A VARIAVEL
            var tpReg = ''

            // VERIFICA O TIPO DO REGISTRO
            switch (registros[indexL].type) {
              case 'CREDIT':
                tpReg = 'C'
                break

              case 'PAYMENT':
                tpReg = 'D'
                break

              default:
                tpReg = registros[indexL].type
                break
            }

            // SETA O TIPO DE REGISTROS
            registros[indexL].fin_tp = tpReg

            // VERIFICA O TIPO DE REGISTROS QUE SERÁ PROCESSADO
            if (this.tpRegistro === '' || this.tpRegistro === tpReg) {
              this.tpRegistro = tpReg
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.msgWarn('WEB [400]: Só é possivel inserir um tipo de registro no financeiro de cada vez, sendo ele receita ou despesa.<br/><br/>Por favor verifique!', 'success')

              // MANDA FECHARA JANELA
              this.finRegVariosFechar(false)

              // LIMPA A VARIAVEL
              this.tpRegistro = null

              // FINALIZA O LOOP
              break
            }
          }
          
          // VERIFICA O TIPO DE INFORMAÇÃO QUE DEVE CARREGAR
          switch (this.tpRegistro) {
            case 'C':
              this.campos.centro.nome = 'Tipo de Receita'
              break

            case 'D':
              this.campos.centro.nome = 'Tipo de Despesa'
              break
          }

          // FINALIZA A BUSCA DOS DADOS
          if (this.tpRegistro !== null) {
            callback(registros)
          }
        }
      },
      finRegVariosBuscarTipoDePagamento: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, nome: null }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/config/for-pagamento/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finRegVariosBuscarTipoDePagamento(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.tpPag.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.tpPag.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.tpPag.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finRegVariosBuscarCentroCusto: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // VERIFICA A ROTA QUE DEVE CHAMAR
          var router = ''
          var method = 'GET'

          // VERIFICA O TIPO DE INFORMAÇÃO QUE DEVE CARREGAR
          switch (this.tpRegistro) {
            case 'C':
              router = '/financeiro/config/car-receita/get/'
              break

            case 'D':
              router = '/financeiro/config/car-despesa/get'
              method = 'POST'
              break
          }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, method, queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finRegVariosBuscarCentroCusto(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.centro.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.centro.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.centro.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finRegVariosOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegVariosOnNovoContato: function () {
        // INICIA OS PARAMETROS
        var params = { tipo: 'contato', id: 0, editar: true }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.finRegVariosOnChangeValue(dados, this.campos.id_for.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      finRegVariosInserirFinanceiro: function () {
        // INICIA O VETOR
        var formData = []

        // RODA O VETOR PEGANDO OS VALORES
        for (var indexR in this.registros) {
          // INICIA O VETOR
          var item = { ref: { modulo: 'financeiro' }, parcela: [] }
          
          // SETA O ID DO CONTATO
          item.id_contato = (typeof this.campos.contato.value === 'string' ? this.campos.contato.value : this.campos.contato.value.id)

          // SETA O TIPO DE REGISTRO D = DESPESA E C = RECEITA
          item.fin_tp = this.registros[indexR].fin_tp

          // ADICIONA O VALOR
          item.descricao = this.registros[indexR].memo
          item.obs = 'OFX: ' + this.registros[indexR].id
          item._ofx = this.registros[indexR].id

          // INICIA O ITEM QUE SERÁ INSERIDO
          item.parcela = [ {} ]

          // SETA O VALOR PAGO
          item.parcela[0].valor = this.registros[indexR].valor

          // SETA A DATA DE PAGAMENTO
          item.parcela[0].vcto_pgto = this.registros[indexR]._vcto

          // SETA O NOME DA CONTA
          item.parcela[0].id_conta = (typeof this.campos.conta.value === 'string' ? this.campos.conta.value : this.campos.conta.value.id)

          // SETA O TIPO DE PAGAMENTO
          item.parcela[0].id_pgto = (typeof this.campos.tpPag.value === 'string' ? this.campos.tpPag.value : this.campos.tpPag.value.id)

          // SETA O CENTRO DE CUSTO QUE DEVE UTILIZAR
          item.parcela[0].id_carteira = (typeof this.campos.centro.value === 'string' ? this.campos.centro.value : this.campos.centro.value.id)

          // SETA O STATUS DO REGISTRO
          item.parcela[0].status = '1'

          // ADICIONA O VALOR NO VETOR
          formData.push(item)
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/financeiro', 'POST', { lot: formData }, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // SETA O VALOR QUE SERÁ ATUALIZADO
          var vetor = {}

          // CARREGA O VETOR RECEBIDO
          for (var indexL in retorno.lot) {
            if (retorno.lot[indexL].code === '200') {
              // PEGA O INDEX DO FORMULARIO
              var indexF = retorno.lot[indexL].ref.lot_index

              // PEGA O ID DO REGISTRO
              var id = retorno.lot[indexL].ref.id

              // SETA O VALOR RECEBIDO
              vetor[formData[indexF]._ofx] = (typeof id === 'object' && Array.isArray(id) === true ? id.join() : id)
            }
          }

          // MANDA FECHAR A TELA
          this.finRegVariosFechar(Object.keys(vetor).length >= 1, vetor)
        }, this.finRegVariosSetarStatusGeral)
      }
    }
  }
</script>

